import { V4PricingPlanOrEnterprise } from '@neptune/shared/core-organizations-domain';
import { ModalHookOutput, useGenericModal } from '@neptune/shared/common-business-logic';

export const ADD_PAYMENT_METHOD_MODAL_NAME = 'ADD_PAYMENT_METHOD_MODAL_NAME';
export const CHANGE_STORAGE_FAILURE_MODAL_NAME = 'CHANGE_STORAGE_FAILURE_MODAL';
export const CHANGE_STORAGE_PLACEHOLDER_MODAL_NAME = 'CHANGE_STORAGE_PLACEHOLDER_MODAL';
export const CHANGE_STORAGE_QUOTA_MODAL_NAME = 'CHANGE_STORAGE_QUOTA_MODAL';
export const CHANGE_TRIAL_STORAGE_MODAL_NAME = 'CHANGE_TRIAL_STORAGE_MODAL';
export const TOP_UP_MONITORING_HOURS_MODAL_NAME = 'TOP_UP_MONITORING_HOURS_MODAL';
export const TOP_UP_PLACEHOLDER_MODAL_NAME = 'TOP_UP_PLACEHOLDER_MODAL';
const CHANGE_USER_SEATS_MODAL_NAME = 'CHANGE_USER_SEATS_MODAL';
const DOWNGRADE_PRICING_PLAN_MODAL_NAME = 'DOWNGRADE_PRICING_PLAN_MODAL';

export type ChangeUserSeatsModalData = {
  title?: string;
  targetPlanId?: V4PricingPlanOrEnterprise;
};

export type DowngradePricingPlanModalData = {
  targetPlanId: V4PricingPlanOrEnterprise;
  targetPlanDisplayName: string;
};

export function useChangeUserSeatsModal(data?: ChangeUserSeatsModalData) {
  return useGenericModal<ChangeUserSeatsModalData | undefined>(CHANGE_USER_SEATS_MODAL_NAME, data);
}

export function useDowngradePricingPlanModal(
  data: DowngradePricingPlanModalData,
): ModalHookOutput<DowngradePricingPlanModalData>;
export function useDowngradePricingPlanModal(): Omit<
  ModalHookOutput<DowngradePricingPlanModalData>,
  'open'
>;

export function useDowngradePricingPlanModal(data?: DowngradePricingPlanModalData) {
  return useGenericModal<DowngradePricingPlanModalData>(DOWNGRADE_PRICING_PLAN_MODAL_NAME, data);
}
